import { useConditionFieldPath } from './useConditionFieldPath';

export const useConditionFieldTypeFieldPath = () => {
  const condition = useConditionFieldPath();
  return `${condition}.fieldType` as const;
};
